<template>
  <div class="index">
    <div class="banner">
      <img src="../assets/banner.png" />
    </div>
    <Back />
    <div class="tab">
      <p
        v-for="(item, index) in tabList[value]"
        :key="index"
        :class="value1 == index ? 'active' : ''"
        @click="value1 = index"
      >
        {{ item }}
      </p>
    </div>

    <transition enter-active-class="animated zoomIn">
      <div class="function">
        <video
          style="width: 100%; height: 100%; background: black"
          :src="videoList[value][value1]"
          loop
          controls
          autoplay
        ></video>
      </div>
    </transition>
  </div>
</template>

<script>
import Back from "../components/back.vue";
export default {
  data() {
    return {
      value: 0,
      value1: 0,

      tabList: [
        [],
        ["步行", "汽车"],
        ["访客系统", "智慧物业"],
        ["新风系统预留", "同层排水", "wifi覆盖", "太阳能", "社区监控"],
        ["外立面石材", "大堂", "公共楼道", "防盗门", "窗户"],
        ["楼座面积", "赠送面积"],
      ],

      videoList: [
        [require("../assets/九重安防体系.mp4")],
        [require("../assets/无触感归家--步行.mp4"), require("../assets/cheku.mp4")],
        [
          require("../assets/无触感归家--汽车.mp4"),
          require("../assets/智慧社区-智慧物业.mp4"),
        ],
        [
          require("../assets/智能--新风系统.mp4"),
          require("../assets/智能--同层排水.mp4"),
          require("../assets/智能--社区WIFI.mp4"),
          require("../assets/智能--太阳能系统.mp4"),
          require("../assets/智能--社区监控.mp4"),
        ],
        [
          require("../assets/精工工艺--外立面石材.mp4"),
          require("../assets/精工工艺--大堂.mp4"),
          require("../assets/精工工艺--公共楼道.mp4"),
          require("../assets/精工工艺--防盗门.mp4"),
          require("../assets/精工工艺--窗户.mp4"),
        ],
        [
          require("../assets/剖面--楼座面积.mp4"),
          require("../assets/剖面--赠送面积.mp4"),
        ],
      ],
    };
  },
  components: {
    Back,
  },

  methods: {},

  watch: {},

  created() {
    this.value = this.$route.query.id;
    console.log(this.value);
  },
};
</script>

<style lang="scss" scoped>
.function {
  width: 320px;
  height: 215px;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  background: #fff;
  margin: auto;
  margin-top: 10px;
}
.tab {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 200px;
  p {
    font-size: 14px;
    color: #666;
    line-height: 35px;
  }
  .active {
    color: #ffbc1e;
    position: relative;
    border-bottom: 2px solid #ffbc1e;
  }
}
.index {
  width: 100%;
  height: 100%;
  text-align: center;
  overflow: hidden;
  .list {
    width: 100%;
    height: 65px;
    display: flex;
    justify-content: center;
    background: #fff;
    bottom: 0;
    position: fixed;
    align-items: center;
  }
  .box {
    p {
      font-size: 10px;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      line-height: 18px;
      color: #999;
      margin: 0 20px;
    }
    .active {
      color: #ffbc1e;
    }
  }
}

.banner {
  width: 100%;
  height: 200px;
  position: fixed;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
